import { render, staticRenderFns } from "./OrderFlag.vue?vue&type=template&id=50f064f0&"
import script from "./OrderFlag.vue?vue&type=script&lang=js&"
export * from "./OrderFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Volumes/ExSSD/projects/oee/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../Volumes/ExSSD/projects/oee/admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VIcon,VList,VListItem,VListItemAction,VListItemAvatar,VListItemTitle,VMenu,VSwitch})
